export const ROUTER_NAME = Object.freeze(
    {
        HOME: 'Home',
        DIALOG_QUIZ: 'DialogQuiz',
        GIFT_QUIZ: 'GiftQuiz',
        EXPRESS_QUIZ: 'ExpressQuiz',
        PURELY_QUIZ: 'PurelyQuiz',
        QUIZ_RESULTS: 'QuizResults'
    })